import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil, filter, Subject } from 'rxjs';
import { JobsServicesService } from './jobs-services.service';
import { FormService } from 'src/app/shared/components/form/form.service';
import { AdmobService } from 'src/app/shared/adv/admob.service';
import { UserService } from 'src/app/auth/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-jobs-services',
  templateUrl: './jobs-services.component.html',
  styleUrls: ['./jobs-services.component.scss'],
})
export class JobsServicesComponent implements OnInit, OnDestroy {
  toolbarData = {
    arrowRouter: '/bazaar',
    btnSlot: 'end',
    title: 'Service Exchange',
  };
  tab: string;
  isPremium = false;
  isAdmin;
  isMobile = this.admobService.isMobile;
  isShowPage = false;

  private destroy$ = new Subject<void>();
  isHeaderDisabled = this.isServiceExchangeDetailRoute();

  private sub;

  constructor(
    private router: Router,
    private service: JobsServicesService,
    private userService: UserService,
    private fs: FormService,
    private admobService: AdmobService
  ) {}

  async ngOnInit() {
    this.getUser();
    this.sub = this.service.urlChanged.subscribe(async (e: any) => {
      this.isHeaderDisabled = this.isServiceExchangeDetailRoute(e.url);
      this.logAdLifecycle('service-exchange-url-change', {
        url: e.url,
        isDetailRoute: this.isHeaderDisabled,
      });
      if (this.isHeaderDisabled) {
        this.isHeaderDisabled = true;
        const app: HTMLElement = document.querySelector('ion-router-outlet');
        app.style.marginBottom = '0px';
      }
    });
  }

  async ngOnDestroy() {
    this.sub.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    this.fs.jobsMenuData$.next(false);
  }

  async ionViewWillEnter() {
    this.isShowPage = true;
    this.isHeaderDisabled = this.isServiceExchangeDetailRoute();
    this.logAdLifecycle('service-exchange-enter', {
      isDetailRoute: this.isHeaderDisabled,
    });
  }

  ionViewWillLeave() {
    this.logAdLifecycle('service-exchange-leave');
    this.isShowPage = false;
  }

  getSelected(_e) {
    this.tab = _e;
    _e === 'jobs'
      ? this.fs.servicesMenuData$.next(false)
      : this.fs.jobsMenuData$.next(false);
  }

  private getUser() {
    this.userService.currentUser$
      .pipe(
        takeUntil(this.destroy$),
        filter(user => !!user.uid)
      )
      .subscribe(async user => {
        this.isAdmin = this.userService.isAdmin;
        this.isPremium = this.userService.isPremium;
        if (!this.isAdmin && this.isMobile && !this.isPremium) {
          this.logAdLifecycle('service-exchange-gate-show');
        } else {
          this.logAdLifecycle('service-exchange-gate-remove', {
            isAdmin: this.isAdmin,
            isPremium: this.isPremium,
            isMobile: this.isMobile,
          });
        }
      });
  }

  isServiceExchangeDetailRoute(url = this.router.url) {
    const cleanUrl = (url || '').split('?')[0].split('#')[0];
    return (
      cleanUrl.includes('/bazaar/job&services/services/') ||
      cleanUrl.includes('/bazaar/job&services/jobs/')
    );
  }

  private logAdLifecycle(event: string, extra: Record<string, unknown> = {}) {
    if (environment.production) {
      return;
    }

    console.log('[admob-lifecycle]', {
      component: 'service-exchange',
      event,
      path: window.location.pathname,
      routerUrl: this.router.url,
      isMobile: this.isMobile,
      isPremium: this.isPremium,
      isAdmin: this.isAdmin,
      ...extra,
    });
  }
}
